import { createUseStyles } from 'react-jss';

const useStyles = createUseStyles((theme) => ({
  container: {
    borderRadius: '8px',
    margin: '0 15.5px',
    background: 'white',
    transform: 'translate(0, -50%)',
    boxShadow: '0px 0px 10px rgba(0, 0, 0, 0.1)',
    '& div[role=button]': {
      borderRadius: '8px',
    },
  },
  productDetailsContainer: {
    borderBottom: `1px solid ${theme.palette.neutralBackground}`,
    padding: `${theme.spacing.small} 0`,
  },
  productImage: {
    width: '56px',
    height: '56px',
    borderRadius: '8px',
    border: '1px solid #ECEBEC',
  },
  angleRightIcon: {
    paddingRight: 0,
  },
}));

export default useStyles;
